import { VACATION_SUFFIX } from '../dialogs/start-planning-dialog/store/start-planning.const';

const VACATION_MARKER = new RegExp(`-${VACATION_SUFFIX.name}-`, 'i');

/**
 * The plan name as the dialogs show it: a vacation plan `PAR-SE-Vacation-2028` reads
 * `PAR-SE-2028`, any other name stays as it is (#5182).
 */
export function toPlanLabel(planName: string | null | undefined): string {
  return (planName ?? '').replace(VACATION_MARKER, '-');
}
